import { assert } from '@ember/debug';
import { MilestonesVariantTypes } from '@square/dashboard-data/models/squareup/setup-guide/config/milestones';
import { buttonClickEvent, showEvent, modalOpenEvent, modalCloseEvent } from '@dashboard/junk-drawer/utils/eventstream';
export const ACTION_ITEM_MODAL_CONTINUE_REASON = 'continue';
export const ACTION_ITEM_MODAL_SKIP_REASON = 'skip';
export const ACTION_ITEM_MODAL_DISMISS_REASON = 'dismiss';
function pageClickAction(name) {
  return {
    page_click_action: name
  };
}
export function actionItemModalClosed(reason, actionItemName) {
  return buttonClickEvent(`Setup Guide: Action Item Modal Closed: ${reason}`, pageClickAction(actionItemName));
}
export function actionItemComplete(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Complete', pageClickAction(actionItemName));
}
export function actionItemDismissed(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Dismissed', pageClickAction(actionItemName));
}
export function actionItemClicked(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Clicked', pageClickAction(actionItemName));
}
export function actionItemVideoPlayed(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Video Played', pageClickAction(actionItemName));
}
export function actionItemVideoEnded(actionItemName) {
  return showEvent('Setup Guide: Action Item Video Ended', pageClickAction(actionItemName));
}
export function actionItemVideoWatched(actionItemName, progress) {
  return showEvent('Setup Guide: Action Item Video Watched', {
    page_click_action: actionItemName,
    page_click_detail: progress
  });
}
export function walkthroughStepCompleted(actionItemName, stepName) {
  return buttonClickEvent(`Setup Guide: Walkthrough Step Completed For Action Item: ${actionItemName}`, pageClickAction(stepName));
}
export function walkthroughCompleted(actionItemName) {
  return buttonClickEvent('Setup Guide: Walkthrough Completed', pageClickAction(actionItemName));
}
export function actionItemCompletePopoverClose(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Complete Popover Close Clicked', pageClickAction(actionItemName));
}
export function actionItemCompletePopoverNext(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Complete Popover Next Clicked', pageClickAction(actionItemName));
}
const WATCH_RETAIL_TOUR_VIDEO_BASE = 'Watch Retail Tour';
const WATCH_RST_TOUR_VIDEO_BASE = 'Watch Restaurants Tour';
function milestoneVideoEventName(milestonesVariant, eventName, eventType) {
  switch (milestonesVariant) {
    case MilestonesVariantTypes.RETAIL:
      return `${WATCH_RETAIL_TOUR_VIDEO_BASE}: ${eventName}`;
    case MilestonesVariantTypes.RST: // fall-through
    case MilestonesVariantTypes.RST_FREE:
      return `${WATCH_RST_TOUR_VIDEO_BASE}: ${eventName}`;
    case MilestonesVariantTypes.MIXED:
      return `${eventType}: ${eventName}`;
    default:
      assert('Must supply valid MilestonesVariantTypes.');
      return `${eventName}`;
  }
}
export function milestoneVideoModalOpen(milestonesVariant, eventType) {
  return modalOpenEvent(milestoneVideoEventName(milestonesVariant, 'Modal Open', eventType));
}
export function milestoneVideoModalClose(milestonesVariant, eventType) {
  return modalCloseEvent(milestoneVideoEventName(milestonesVariant, 'Modal Close', eventType));
}
export function milestoneVideoPlayed(milestonesVariant, eventType) {
  return buttonClickEvent(milestoneVideoEventName(milestonesVariant, 'Play Video', eventType));
}
export function milestoneVideoEnded(milestonesVariant, eventType) {
  return showEvent(milestoneVideoEventName(milestonesVariant, 'Video Ended', eventType));
}
export function milestoneVideoWatched(progress, milestonesVariant, eventType) {
  return showEvent(milestoneVideoEventName(milestonesVariant, 'Video Watched', eventType), {
    page_click_detail: progress
  });
}
const WATCH_ACTION_ITEM_VIDEO_BASE = 'Watch Setup Guide Action Item Modal';
export function actionItemVideoModalClose(actionItemName) {
  return modalCloseEvent(`${WATCH_ACTION_ITEM_VIDEO_BASE}: Modal Close`, pageClickAction(actionItemName));
}
export function actionItemVideoModalOpen(actionItemName) {
  return modalOpenEvent(`${WATCH_ACTION_ITEM_VIDEO_BASE}: Modal Open`, pageClickAction(actionItemName));
}
export function actionItemVideoModalPlayed(actionItemName) {
  return buttonClickEvent(`${WATCH_ACTION_ITEM_VIDEO_BASE}: Play Video`, pageClickAction(actionItemName));
}
export function actionItemVideoModalWatched(actionItemName, progress) {
  return showEvent(`${WATCH_ACTION_ITEM_VIDEO_BASE}: Video Watched`, {
    page_click_action: actionItemName,
    page_click_detail: progress
  });
}
export function actionItemVideoModalEnded(actionItemName) {
  return showEvent(`${WATCH_ACTION_ITEM_VIDEO_BASE}: Video Ended`, pageClickAction(actionItemName));
}
const SETUP_GUIDE_BANNER_BASE = 'Setup Guide Banner';
export function setupGuideBannerVideoPlay(actionItemName) {
  return buttonClickEvent(`${SETUP_GUIDE_BANNER_BASE}: Play Video`, pageClickAction(actionItemName));
}
export function setupGuideBannerVideoDismiss(actionItemName) {
  return buttonClickEvent(`${SETUP_GUIDE_BANNER_BASE}: Dismiss Video`, pageClickAction(actionItemName));
}
export function setupGuideBannerVideoWatched(actionItemName, progress) {
  return showEvent(`${SETUP_GUIDE_BANNER_BASE}: Video Watched`, {
    page_click_action: actionItemName,
    page_click_detail: progress
  });
}
export function actionItemStarted(actionItemName) {
  return buttonClickEvent('Setup Guide: Action Item Started', pageClickAction(actionItemName));
}